export default function Font_Color() {
  return (
    <div className="p-4">
      <h1>Font Color</h1>
    </div>
  );
}
